import { useRef, useState } from 'react';
import Debounce from '../CommonComponent/debounce';
import { dataService } from '../services/dataService';

const SLUG_FORMAT_REGEX = /^[a-z0-9][a-z0-9-]*[a-z0-9]$|^[a-z0-9]$/;

export default function useVanitySlug({ auctionData, setAuctionData, setEditedAuctionData }) {
    const [slugError, setSlugError] = useState('');
    const [isFormatInvalid, setIsFormatInvalid] = useState(false);
    const [isTaken, setIsTaken] = useState(false);
    const [slugSuccess, setSlugSuccess] = useState('');
    const [checkingSlug, setCheckingSlug] = useState(false);

    const checkSlugAvailability = useRef(Debounce(async (slug, auctionId) => {
        const result = await dataService.CheckSlugAvailability(slug, auctionId || '');
        setCheckingSlug(false);
        if (result.error) {
            setIsTaken(true);
            const message = result.message?.status === 403
                ? (result.message?.data?.message || 'This action is not permitted for your account.')
                : (result.message?.data?.message || 'This URL is unavailable, please try another');
            setSlugError(message);
            setSlugSuccess('');
        } else if (!result.data.available) {
            setIsTaken(true);
            setSlugError('This URL is unavailable, please try another');
            setSlugSuccess('');
        } else {
            setIsTaken(false);
            setSlugError('');
            setSlugSuccess('This URL is available');
        }
    })).current;

    const handleSlugChange = (rawValue) => {
        const slug = rawValue.toLowerCase();
        if (slug.length > 50) return;

        setAuctionData((prevData) => ({ ...prevData, vanity_slug: slug }));
        setEditedAuctionData((prevData) => ({ ...prevData, vanity_slug: slug }));
        setSlugSuccess('');
        setIsTaken(false);

        if (slug === '') {
            checkSlugAvailability.cancel();
            setSlugError('');
            setIsFormatInvalid(false);
            setCheckingSlug(false);
            return;
        }
        if (slug.length < 3 || !SLUG_FORMAT_REGEX.test(slug)) {
            checkSlugAvailability.cancel();
            setIsFormatInvalid(true);
            setCheckingSlug(false);
            setSlugError(slug.length < 3
                ? 'URL must be 3-50 characters.'
                : 'Only lowercase letters, numbers, and hyphens (no leading/trailing hyphens).');
            return;
        }
        setIsFormatInvalid(false);
        setSlugError('');
        setCheckingSlug(true);
        checkSlugAvailability(slug, auctionData._id);
    };

    return {
        slug: auctionData.vanity_slug || '',
        slugError,
        slugSuccess,
        checkingSlug,
        isFormatInvalid,
        isTaken,
        handleSlugChange,
        isSaveBlocked: Boolean(slugError) || checkingSlug,
    };
}
